import { CHARTER_PROMOTION_TYPES } from 'constants/charterFlight'
import { OptimizelyFeatureFlags } from 'constants/featureFlags'
import useFeatureFlag from 'hooks/Experiments/useFeatureFlag'
import useCharterFlightPromotionAvailableSeats from 'hooks/Flights/useCharterFlightPromotionAvailableSeats'
import { useAppSelector } from 'hooks/reduxHooks'
import { isLEStaff } from 'selectors/accountSelectors'
import { getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import { isAgentHubEnabled } from 'agentHub/selectors/isAgentHubEnabled'

interface ReturnForFreeSaleAvailability {
  /** The campaign is switched on for this visitor, regardless of remaining inventory. */
  isSaleEnabled: boolean
  /** Inventory has resolved and the promotion still has seats. */
  hasSeatsRemaining: boolean
  /** The campaign should be advertised: enabled, and not yet sold out. */
  isSaleVisible: boolean
}

export default function useReturnForFreeSaleAvailability(): ReturnForFreeSaleAvailability {
  const isFeatureEnabled = useFeatureFlag(OptimizelyFeatureFlags.maldivesCharterReturnFlightFree)
  const isStaff = useAppSelector(isLEStaff)
  const isLuxPlusEnabled = useAppSelector(getIsLuxPlusEnabled)

  // The Optimizely allowlist already keeps this off non-LuxPlus+ brands, but that is config, not code.
  const isSaleEnabled = isFeatureEnabled && isLuxPlusEnabled && !isAgentHubEnabled && !isStaff

  const { availableSeats, isLoading } = useCharterFlightPromotionAvailableSeats({
    enabled: isSaleEnabled,
    promotionType: CHARTER_PROMOTION_TYPES.returnForFree,
  })

  const hasSeatsRemaining = !isLoading && availableSeats > 0

  return {
    isSaleEnabled,
    hasSeatsRemaining,
    isSaleVisible: isSaleEnabled && hasSeatsRemaining,
  }
}
